/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSaveFilled = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-save-filled',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M11.55.918a.5.5 0 0 1 .9 0l3.258 6.659 7.297 1.075a.5.5 0 0 1 .278.852L18 14.694l1.246 7.324a.5.5 0 0 1-.727.526L12 19.087l-6.518 3.457a.5.5 0 0 1-.728-.526L6 14.693.717 9.503a.5.5 0 0 1 .278-.85l7.297-1.076 3.259-6.66Z" })));
});
IconSaveFilled.displayName = 'IconSaveFilled';
export default IconSaveFilled;
